import { UserStatusT } from "../context/GetLifeContext.context";
import USER_STATUS from "./RecoverUserStatus";
import { FEATURE_FLAGS, getFeatureFlag } from "../utils/featureFlags";
import { customerProjectsEnabled, isNativeMode } from "../native/nativeMode";

/**
 * Upsell A/B test (`payment-new-page-test`): maps the PostHog flag variant to
 * the upsell route. Any other value (incl. flags not loaded / not in PRD)
 * falls back to control via the default route below.
 */
const UPSELL_VARIANT_PATHS: Record<string, string> = {
  control: "/payment/1",
  test: "/paymentNew/1",
};

export const getDefaultRoute = (userStatus: UserStatusT): string => {
  if (userStatus === "upsell_pending") {
    // Organic native: el upsell es PaymentGatewayV2 (NativeUpsell), en /paymentNew.
    // El legacy /payment/1 (CandidateModeBoundary + pricing-capabilities) no aplica.
    if (isNativeMode()) {
      return "/paymentNew/1";
    }
    const variant = getFeatureFlag(FEATURE_FLAGS.paymentNewPageTest);
    if (typeof variant === "string" && UPSELL_VARIANT_PATHS[variant]) {
      return UPSELL_VARIANT_PATHS[variant];
    }
  }
  return USER_STATUS[userStatus][0];
};

export const redirect = (userStatus: UserStatusT) => {
    const getroute = window.location.pathname;
    // Portal Cliente como entrada única: el cliente native se queda en el Dashboard
    // tenga o no póliza (desde ahí retoma su cotización o empieza otra). Sin esto,
    // el getStatus del Dashboard lo devolvería al paso del funnel de su estado.
    if (customerProjectsEnabled() && getroute.startsWith("/dashboard")) {
        return getroute;
    }
    // Recién logueado: la guardia de rutas públicas re-pinta /login con el token ya
    // puesto y redirige por estado ANTES de que la pantalla de login navegue. Ambas
    // tienen que llevar al mismo sitio: el Dashboard.
    if (customerProjectsEnabled() && getroute.startsWith("/login")) {
        return "/dashboard/global";
    }
    if (USER_STATUS[userStatus].includes(getroute)) {
        return getroute;
    } else return getDefaultRoute(userStatus)
}
